'use strict'

import firebase from 'firebase/app'
import 'firebase/auth'

const config = require('AppConfig')

/**
 * リダイレクト処理クラス
 */
class Redirect {
    /**
     * ログイン・未ログイン判定
     * @returns {Promise}
     */
    watch = async () => {
        let self = this
        let path = window.location.pathname

        // ログインユーザー情報を取得
        let unsubscribe = firebase.auth().onAuthStateChanged(user => {
            unsubscribe()

            // ローカルストレージに追加項目表示のフラグが入っていたらリダイレクト
            let additionalDictFlag = window.localStorage.getItem('additionalDict')
      
            if (additionalDictFlag
                && !this.pathMatch(path, config.path.profile)
                && !this.pathMatch(path, config.path.changemail)
                && !this.pathMatch(path, config.path.registmail)
                && !this.pathMatch(path, config.path.terms)
                && !this.pathMatch(path, config.path.login)
                && !this.pathMatch(path, config.path.signup)
                && !this.pathMatch(path, config.path.forgotpw)
                && !this.pathMatch(path, config.path.changepasswd)
                && !this.pathMatch(path, config.path.usermgmt)
                && !this.pathMatch(path, config.path.withdrawal)
                ) {    
                location.href = config.path.profile
            }

            if (user) {
                self.doRedirect(user)
            } else {
                //未ログインの場合
                if (
                    this.pathMatch(path, config.path.profile) ||
                    this.pathMatch(path, config.path.registmail) ||
                    this.pathMatch(path, config.path.changemail) ||
                    this.pathMatch(path, config.path.changepasswd) ||
                    this.pathMatch(path, config.path.withdrawal)
                ) {
                    location.href = config.path.login
                }
            }
        })
    }

    /**
     * リダイレクト実行
     * @param {object} user firebaseから取得するuser情報
     * @returns {void}
     */
    doRedirect = user => {

        let path = window.location.pathname
        let uid = user.uid

        if (user) {
            //ログイン中どのような状況であってもリダイレクトを行わないページ
            if (
                this.pathMatch(path, config.path.usermgmt) ||
                this.pathMatch(path, config.path.changepasswd)
            ) {
                return
            }

            // ローカルストレージにcontinueUrlが入っていればリダイレクトする
            let continueUrl = window.localStorage.getItem('continueUrl')
            if (continueUrl) {
                window.localStorage.removeItem('continueUrl')

                if (
                    this.pathMatch(continueUrl, config.path.registmail) ||
                    this.pathMatch(continueUrl, config.path.changemail)
                ) {
                    location.href = continueUrl
                }
                // 退会時のSNS再認証後のリダイレクト処理
                else if (this.pathMatch(continueUrl, config.path.withdrawal)) {
                    location.href = continueUrl
                }
            }

            firebase
                .firestore()
                .collection(config.collections.userData)
                .doc(uid)
                .get()
                .then(doc => {
                    if(
                        doc.exists &&
                        (
                            typeof doc.data()["raw_prefecture"] === "undefined"
                            || typeof doc.data()["raw_occupation"] === "undefined"
                            || typeof doc.data()["raw_position"] === "undefined"
                            || typeof doc.data()["raw_employee_scale"] === "undefined"
                            || typeof doc.data()["raw_industry"] === "undefined"
                            || typeof doc.data()["raw_domestic_base_number"] === "undefined"
                            || typeof doc.data()["raw_overseas_base_number"] === "undefined"
                        ) 
                        && !this.pathMatch(path, config.path.profile)
                        && !this.pathMatch(path, config.path.changemail)
                        && !this.pathMatch(path, config.path.registmail)
                        && !this.pathMatch(path, config.path.terms)
                    ){
                        // 途中追加の必須項目が未入力の場合はプロフィールページへリダイレクト
                        location.href = config.path.profile
                    }
                    else if (
                        // ペイウォールからのアクセスかチェック
                        doc.exists &&
                        (this.pathMatch(path, config.path.login) ||
                            this.pathMatch(path, config.path.signup)) &&
                        window.localStorage.getItem('paywall')
                    ) {
                        // ローカルストレージにpaywallが入っていた場合元の記事ページにリダイレクトする
                        // ここでの処理は、ペイウォールからログインした、すでにプロフィール登録済みのユーザを想定
                        let paywallUrl = window.localStorage.getItem('paywall')

                        window.localStorage.removeItem('paywall')
                        location.href = paywallUrl
                    }
                    // ユーザー情報未登録の場合はプロフィールページへリダイレクト
                    // ログインページの場合もリダイレクト
                    else if (
                        !doc.exists ||
                        this.pathMatch(path, config.path.login) ||
                        this.pathMatch(path, config.path.signup)
                    ) {
                        if (
                            (this.pathMatch(path, config.path.changemail) ||
                                !user.emailVerified ||
                                !user.email) &&
                            !this.pathMatch(path, config.path.registmail)
                        ) {
                            //ログイン後 初回（emailのデータがない）
                            location.href = config.path.registmail
                        } else if (
                            !this.pathMatch(path, config.path.profile) &&
                            !this.pathMatch(path, config.path.registmail)
                        ) {
                            location.href = config.path.profile
                        }
                    } else {
                        //ドキュメントが存在
                        if (
                            (this.pathMatch(path, config.path.registmail) ||
                                !user.emailVerified) &&
                            !this.pathMatch(path, config.path.changemail)
                        ) {
                            //メールアドレス変更手続き中
                            location.href = config.path.changemail
                        }
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }

    /**
     * ケツのスラ有り無しで判定が狂うことがあるので一旦両方のパスのケツに「/」を足して比較
     * @param {string} p1 比較対象のパス
     * @param {string} p2 比較対象のパス
     * @returns {boolean} 一致したらtrueを返却
     */
    pathMatch = (p1, p2) => {
        p1 = p1 + '/'
        p1 = p1.replace(/\/\/$/, '/')

        p2 = p2 + '/'
        p2 = p2.replace(/\/\/$/, '/')

        return p1 == p2
    }
}
const redirect = new Redirect()
export default redirect
